import { BranchMetrics } from "../@types/branch";
import axios from "../axiosInstance";

export const getBranchesMetrics = async () => {
    try {
        let response = await axios.get('/api/branch-hierarchy/metrics');
        const data: BranchMetrics = response.data;
        return data
    } catch (error) {
        console.error(error)
    }
};